import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CloudPremisePlugin, useAuthProvider } from "@cloudpremise/portal_core";
import { routes, menus, userMenus, footerMenus, settingMenus } from "./src";
import packageJson from "./package.json";

class ServiceDesk extends CloudPremisePlugin {};

const ServiceDeskPlugin = new ServiceDesk ({
    name: packageJson.name,
    description: packageJson.description,
    status: packageJson.status,
    routes: routes,
    menus: menus,
    userMenus: userMenus,
    footerMenus: footerMenus,
    settingMenus: settingMenus,
    render: (props: any) => {
        return <ServiceDeskPluginRender key="servicedesk" {...props} />
    }
});

const ServiceDeskPluginRender = (props: any) => {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    React.useEffect(() => {
        if(pathname === "/home"){
            // return navigate("/servicedesk/cases", { replace: true });
        }
    }, [pathname]);
    return null
};

export default ServiceDeskPlugin;